const ErrorMessage = ({ message }:any) => {
    if (message?.length == 0) return null;
    return (
        <p className='error-field'>{message}</p>
    );
};

export default ErrorMessage;